import React, { Component } from "react";
import { connect } from "react-redux";
import disableBrowserBackButton from "disable-browser-back-navigation";
import Modal from "react-bootstrap/Modal";
import xss from "xss";
import axios from "axios";

import { useNavigate } from "../utils/components/router";
import { BeendenButton } from "../utils/components";
import { RAGE_RIGHT } from "../utils/enums/RAGE_RIGHT";
import PageHeader from "./PageHeader";
import { basketActions, pageActions } from "../actions";
import CONFIG from "../config";
import KundeLogin from "./KundeLogin";
import { checkResize, isAuthenticated, download, uniqueKey } from "../utils/functions";
import { BackToStartButton } from "../partial";
import { konditionenActions } from "../reducers/konditionen-reducer";

class KundenDankeSeiteMA extends Component {
  constructor(props) {
    super(props);
    this.handleBackToShop = this.handleBackToShop.bind(this);
    this.getPdfFromWebservice = this.getPdfFromWebservice.bind(this);
    this.resetMitarbeiterKonditionen = this.resetMitarbeiterKonditionen.bind(this);
  }

  componentDidMount() {
    disableBrowserBackButton();
    checkResize();
    this.setState({ errorMsg: this.props.errorMsg ? this.props.errorMsg : null });
  }

  state = {
    errorMsg: null,
  };

  async getPdfFromWebservice() {
    const apiCall = this.props.configStorage.getApiRequest("orderPdf");
    const warenkorbId = this.props.basketStorage.warenkorbId;
    apiCall(warenkorbId, (error, data, response) => {
      if (!error) {
        download(response.body, "orderPdf.pdf");
      }
      if (!response || !response.ok) {
        this.setState({ errorMsg: [response ? xss(response.message) || "Fehler: " + response.statusText : "Keine Daten erhalten"] });
      }
    });
  }

  resetMitarbeiterKonditionen() {
    this.props.dispatch(konditionenActions.setMaKond(false));
  }

  handleBackToShop(e) {
    e.preventDefault();
    this.props.dispatch(konditionenActions.setMaKond(false));
    this.props.dispatch(pageActions.setOverviewPage());
    this.props.dispatch(basketActions.resetWarenkorb());
    this.props.navigate(this.props.configStorage.getBackToShopLink());
  }

  async handleEndTransactionDB(e) {
    if (CONFIG.NODE_ENV === 'development') {
      return;
    }

    // TODO: Adapt to actual requirement, following just template for call.
    let requestData = this.props.configStorage.getRequestData("endTransactionDB", "post");
    let header = this.props.configStorage.getRequestHeader();
    let config = {
      headers: {
        request: JSON.stringify(header)
      }
    };
    const endTransactionData = {};
    const axiosVerify = axios.create(config);
    const response = await axiosVerify[requestData.request.type](
      requestData.url,
      endTransactionData
    );

    if (response.data && response.data.error) {
      // handle error
      this.resetData();
      this.setState({ showErrorMsg: true, warningMsg: response.data.error });
      return this.props.navigate("/error", response.data.error);
    }
  }

  render() {
    const { configStorage, basketStorage } = this.props;
    if (!isAuthenticated(this.props)) {
      return (<KundeLogin></KundeLogin>);
    }
    let headerText = configStorage.isMaShop()
      ? "Vielen Dank für Ihre Order. Ihr Auftrag wurde zur Bearbeitung weitergeleitet."
      : "Vielen Dank für Ihren Einkauf. Ihr Auftrag wird nun für Sie bearbeitet.";
    let bodyText = `Die Auftragsbestätigung wurde an Ihre E-Mail-Adresse verschickt.
       Sie haben zusätzlich die Möglichkeit die Bestätigung hier als pdf-Datei zu öffnen.`;
    if (configStorage.isAnkaufShop()) {
      bodyText = `Der Auftrag wurde erfolgreich übermittelt. Bitte legen Sie die ausgedruckte Auftragsbestätigung zusammen mit der angekauften Ware in den Safebag.`;
    }
    let className = "text-h2-secondary";
    if (configStorage.isVerseNeo()) {
      className = "text-primary";
      headerText = "Auftragsbestätigung";
      bodyText = basketStorage.getBankApiResponseData().bankApiResponse || bodyText;
    }
    return (
      <div id={CONFIG.SHOP_ID} className="if6_outer section if6_section">
        <PageHeader />
        <section className="bootstrap-iso">
          <div className="container bg-white pt-one pb-two">
            <div className="row justify-content-center">
              <div className="col-12 col-md-11 col-lg-10">
                <Modal.Dialog size="lg" className="info">
                  <Modal.Header>
                    <Modal.Title>
                      <h2 className={className}>
                        {headerText}
                      </h2>
                    </Modal.Title>
                  </Modal.Header>
                  <Modal.Body>
                    {this.state.errorMsg !== null
                      ? this.state.errorMsg.map((abschnitt) =>
                        <p key={uniqueKey(abschnitt)} className="text-left fw-bold fs-6">{xss(abschnitt)}</p>
                      )
                      : configStorage.isAnkaufShop() || configStorage.isVerseNeo() ?
                      <p>
                        {bodyText}
                      </p> : null  
                    }
                  </Modal.Body>
                  <Modal.Footer>
                    <button
                      className="btn btn-default col-12 col-md-4 text-center deuba_green_button"
                      onClick={this.getPdfFromWebservice}
                      id="admin-btn"
                      aria-label="Auftragsbestätigung als PDF öffnen"
                    >
                      Auftragsbestätigung öffnen
                    </button>
                    <div className="row d-flex justify-content-between w-100 mt-one">
                      <button type="button"
                        onClick={this.handleBackToShop}
                        className="btn btn-info col-12 col-md-4"
                      >
                        Zurück zum Shop
                      </button>

                      {/*this.state.errorMsg === null ? 
                        (
                          <button type="button"
                            onClick={this.handleEndTransactionDB}
                            className="btn btn-info col-12 col-md-4 db-only"
                          >
                            Transaktion beenden
                          </button>
                        ) : null
                      */}
                      {!configStorage.isKundenShop() && configStorage.isVerseNeo() && this.props.mandantStorage.isSparkasseThemeActive()
                        ? <BackToStartButton onClick={this.resetMitarbeiterKonditionen} />
                        : null
                      }
                      {this.props.mandantStorage.isSparkasseThemeActive() ?
                        ( <BeendenButton className="col-12 col-md-4" variant="default" /> ) : ""
                      }                      
                    </div>                    
                  </Modal.Footer>
                </Modal.Dialog>                
              </div>              
            </div>{" "}            
          </div>          
        </section>        
      </div>
    );
  }
}

export default connect(store => {
  return {
    basketStorage: store.basketStorage,
    configStorage: store.configStorage,
    rightStorage: store.rightStorage,
    mandantStorage: store.mandantStorage,
    authenticationStorage: store.authenticationStorage,
    requiredRageRight: [RAGE_RIGHT.RAGE_BERATER_EINS, RAGE_RIGHT.RAGE_BERATER_ZWEI]
  };
})((props) => {
  const navigate = useNavigate();
  const contextNavigate = props.configStorage.contextNavigate(navigate);
  return <KundenDankeSeiteMA navigate={contextNavigate} {...props} />;
});
